<template>
  <div class="cateDiv">
    <ul>
      <li
        v-for="cat in displayCategories"
        :key="cat.id"
        :class="{ on: isActiveCategory(cat) }"
      >
        <router-link :to="'/product/' + cat.categorySlug + '/'">
          {{ categoryLabel(cat) }}
          <em class="flexcen"><i class="font_family icon-zhankai"></i><i class="font_family icon-shouqi"></i></em>
        </router-link>
        <div class="aDiv" v-if="getProducts(cat.id).length">
          <router-link
            v-for="p in getProducts(cat.id)"
            :key="p.id"
            :to="'/product/' + cat.categorySlug + '/' + p.id + '.html'"
            :class="{ on: String(activeProductId) === String(p.id) }"
          >
            {{ $cleanBrand(p.productName) }}<i class="font_family icon-youjiantou"></i>
          </router-link>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { listProductCategory, listProduct } from '@/utils/http'
import { unwrapRows } from '@/utils/content'
import { isSameProductSlug } from '@/constants/productSlugs'

export default {
  name: 'ProductSidebar',
  props: {
    activeSlug: { type: String, default: '' },
    activeProductId: { type: [String, Number], default: null }
  },
  data() {
    return { categories: [], products: [] }
  },
  computed: {
    displayCategories() {
      return this.categories.filter(cat => {
        if (!cat.categorySlug || cat.status === 0) return false
        if (/^\d+$/.test(String(cat.categorySlug))) return false
        return true
      })
    }
  },
  created() {
    this.load()
  },
  methods: {
    reloadCmsData() {
      this.load()
    },

    categoryLabel(cat) {
      return this.$navItemLabel('productNav', cat)
    },

    isActiveCategory(cat) {
      return isSameProductSlug(this.activeSlug, cat.categorySlug)
    },

    async load() {
      const locale = this.$i18n.locale
      try {
        const [catRes, prodRes] = await Promise.all([
          listProductCategory({ status: 1, pageNum: 1, pageSize: 50 }, locale),
          listProduct({ status: 1, pageNum: 1, pageSize: 500 }, locale)
        ])
        const cats = unwrapRows(catRes)
        if (cats.length) {
          this.categories = cats.sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))
          this.products = unwrapRows(prodRes)
        } else {
          this.categories = []
          this.products = []
        }
      } catch (e) {
        this.categories = []
        this.products = []
      }
    },

    getProducts(catId) {
      const cat = this.categories.find(c => Number(c.id) === Number(catId))
      if (!cat) return []
      const cid = Number(catId)
      return this.products
        .filter(p => {
          if (Number(p.categoryId) === cid) return true
          const linked = this.categories.find(c => Number(c.id) === Number(p.categoryId))
          return linked && linked.categorySlug === cat.categorySlug
        })
        .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0) || Number(a.id) - Number(b.id))
    }
  }
}
</script>
